import Box from "@mui/material/Box";
import React, {ChangeEvent, useEffect, useState} from "react";
import {graphQLServices} from "../../../../services/GraphQLServices";

import {Button, CircularProgress, List, ListItem, Typography} from "@mui/material";
import {Delete, Download} from "@mui/icons-material";
import {GET_FILE_PRESIGNED_URL} from "../graphql/queries/gqlGetFilePresignedUrl";
import {IPresignedUrl} from "../interfaces/IPresignedUrl";
import {toast} from "react-toastify";
import {ConfirmationDialog} from "../../../../components/common/confirmation-dialog/ConfirmationDialog";
import {GET_FILES} from "../graphql/queries/gqlGetFiles";
import {DELETE_FILE} from "../graphql/mutations/gqlDeleteFile";
import {GET_FILESZIPPED_PRESIGNED_URL} from "../graphql/queries/gqlGetFilesZippedPresignedUrl";

interface IFilesCard{
	id?: number;
	type: string;
	allowUpload?: boolean;
}


export const FilesCard: React.FC<IFilesCard> = (props) => {
	const [loading, setLoading] = useState(true);
	const [files, setFiles] = useState<string[]>([]);
	const [filesTrigger, setFilesTrigger] = useState<number>(0);
	useEffect(() => {
		setLoading(true);
		if (props.id) {
			graphQLServices.querytoolClient.query({
				query: GET_FILES,
				variables: {
					"id": props.id,
					"entityType": props.type
				},
			})
				.then((result) => {
					setFiles(result.data.files);
				})
				.finally(() => setLoading(false));
		} else {
			setLoading(false);
		}
		// eslint-disable-next-line
	},[props.id,filesTrigger ]);
	
	const onDownload = (file: string) => {
		setLoading(true);
		graphQLServices.querytoolClient.query({
			query: GET_FILE_PRESIGNED_URL,
			variables: {
				"id": props.id,
				"entityType": props.type,
				"fileName": file,
				"httpVerb": "GET"
			},
		})
			.then((result) => {
				fetch(result.data.filePresignedUrl.url,
					{
						headers: new Headers({"content-type": result.data.filePresignedUrl.contentType}),
					})
					
					.then((response) => {
						response.blob().then((blob) => {
							const fileURL =
							window.URL.createObjectURL(blob);
						
							const alink = document.createElement("a");
							alink.setAttribute("Content-Type", result.data.filePresignedUrl.contentType);
							alink.href = fileURL;
							alink.download = file;
							alink.click();
						});
					});
				
			})
			.finally(() => setLoading(false));
	};
	
	const onDownloadAll = () => {
		setLoading(true);
		graphQLServices.querytoolClient.query({
			query: GET_FILESZIPPED_PRESIGNED_URL,
			variables: {
				"id": props.id
			},
		})
			.then((result) => {
				fetch(result.data.filesZippedPresignedUrl.url,
					{
						headers: new Headers({"content-type": result.data.filesZippedPresignedUrl.contentType}),
					})
					
					.then((response) => {
						response.blob().then((blob) => {
							const fileURL =
								window.URL.createObjectURL(blob);
							
							const alink = document.createElement("a");
							alink.setAttribute("Content-Type", result.data.filesZippedPresignedUrl.contentType);
							alink.href = fileURL;
							alink.download = `files-${props.id}.zip`;
							alink.click();
						});
					});
				
			})
			.finally(() => setLoading(false));
	};
	
	
	async function getPresignedUrlUpload(fileName: string): Promise<IPresignedUrl> {
		setLoading(true);
		let result: IPresignedUrl = {url: "", contentType: ""};
		await graphQLServices.querytoolClient.query({
			query: GET_FILE_PRESIGNED_URL,
			variables: {
				"id": props.id,
				"entityType": props.type,
				"fileName": fileName,
				"httpVerb": "PUT"
			},
			fetchPolicy: "network-only",
		})
			.then(value => result = value.data.filePresignedUrl as IPresignedUrl);
		return result;
	}
	const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
		setLoading(true);
		
		if (!event.target.files) {
			return;
		}
		const file = event.target.files[0];
		
		const uploadUrl = await getPresignedUrlUpload(file.name);
		fetch(uploadUrl.url, {
			method: "PUT",
			body: file,
			headers: new Headers({
				"Content-Type": uploadUrl.contentType,
			})
		}).then(() => {
			toast.success("File is uploaded");
			setFilesTrigger(filesTrigger+1);
		});
	};
	
	const onDelete = (file: string) => {
		graphQLServices.querytoolClient.query({
			query: DELETE_FILE,
			variables: {
				"id": props.id,
				"entityType": props.type,
				"fileName": file,
			},
		})
			.then((result) => {
				toast.success("File is deleted");
				setFilesTrigger(filesTrigger+1);
			})
			.finally(() => setLoading(false));
	};
	
	if (loading) {
		return  <CircularProgress/>;
	}
	
	return ( <><br/>
		<Typography variant="h5" component="h1" align="center" gutterBottom>
				Files
		</Typography>
		{props.allowUpload &&
			<Button variant="outlined" component="label">
				Upload File
				<input
					type="file"
					hidden
					onChange={handleFileUpload}
				/>
			</Button>}
		<Button title={"Download All"} onClick={() => onDownloadAll()}>
				Download All<Download/>
		</Button>
			
		<Box title={"Files"}>
			<List>
				
				{files && files.map((file) => {
					return (
						<ListItem>
							{file}
							<Button onClick={() => onDownload(file)}>
								<Download />
							</Button>
							<ConfirmationDialog
								buttonTitle={<Delete/>}
								onSuccess={() => onDelete(file)}
								dialogTitle={"Are you sure?"}
								dialogDescription={
									"This will permanently delete this file."
								}
							/>

						</ListItem>
					);
				})}
			</List>
		</Box>
	</>
	);
};
